module.exports = __webpack_public_path__ + "static/ALTR-84c96654fea9eb47a98945d8128d3dc6.jpg";